import {initMainHeader} from '../js/src/header-init';
import {loadYoutubeVideoPlayer} from "../js/src/video-list";
import {addThirdPartyLoad} from "../js/src/utils";
import '../scss/pages/about.scss';

initMainHeader();
addThirdPartyLoad(loadYoutubeVideoPlayer)
